import React from "react";
export default class NotFound extends React.Component {
    render() {
        return <h1>잘못된 페이지 접근입니다.</h1>;
    }
}